import React from 'react';
import _ from 'lodash';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import ReactVisibilitySensor from 'react-visibility-sensor';
import BoxedContainer from './layouts/BoxedContainer';

function FreeZoneStats({ id, data }) {
  const items = _.get(data, 'statItems', []);
  const [toggleState, setToggleState] = React.useState(false);

  const handleVisibilityChange = (isVisible) => {
    if (isVisible) setToggleState(true);
  };

  return (
    <section id={id} className="py-12.5 relative z-10">
      <BoxedContainer>
        <div className="w-full grid grid-cols-6 gap-5">
          {_.map(items, (item, key) => {
            // console.log(item.content);
            const itemValue = _.get(item, 'content.value', null);
            const itemTitle = _.get(item, 'content.title', '');
            const itemSubtitle = _.get(item, 'content.subtitle', '');
            const itemUnit = _.get(item, 'content.unit', '');

            return (
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4 * (key + 1) }}
                key={key}
                className="col-span-2 w-full">
                <div className="flex flex-col items-center lg:items-start ltr:gap-[15px] rtl:gap-[10px] w-fit mx-auto">
                  <span
                    className="text-clamp24to40 leading-1 text-red after:inline
                    font-URWDINBold
                    after:content-['+'] flex">
                    <CountUp
                      start={toggleState ? 0 : itemValue}
                      end={itemValue}
                      delay={0}
                      decimal="."
                      decimals={parseFloat(itemValue) % 1 !== 0 ? 1 : 0}>
                      {({ countUpRef }) => (
                        <ReactVisibilitySensor onChange={handleVisibilityChange} delayedCall>
                          <span ref={countUpRef} />
                        </ReactVisibilitySensor>
                      )}
                    </CountUp>
                    {itemUnit}
                  </span>
                  <div className="py-px bg-red w-10 lg:w-12.5" />
                  <div className="flex flex-col items-center gap-[13px] ltr:md:gap-4 rtl:md:gap-2 lg:items-start">
                    <span
                      className="text-clamp16to30 leading-1.5 text-center text-darkGray
                      lg:text-start ltr:font-URWDINRegular rtl:font-GESSTwoDWTCMedium">
                      {itemTitle}
                    </span>
                    <span
                      className="ltr:text-clamp10to14 rtl:text-clamp12to16 uppercase md:ltr:tracking-widest
                      text-center text-liver leading-1 lg:text-start
                      ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight">
                      {itemSubtitle}
                    </span>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </BoxedContainer>
    </section>
  );
}

export default FreeZoneStats;
